export default "__VITE_ASSET__DZAbXflv__"